import { AccountFeatures, AppContext, Features } from "@lightspeed-invoicing/core-client/frontend";
import $ from "jquery";
import React, { Component } from 'react';
import { Button } from 'react-bootstrap';
import { FormattedDate, FormattedMessage, FormattedNumber, injectIntl } from 'react-intl';
import { Link, Redirect } from "react-router-dom";
import BulkModal from "../bulk/modal.component.jsx";
import ActionButton from "../common/button/actionbutton.component.jsx";
import SendSchedulingPageButton from '../common/button/sendSchedulingPageButton.component.jsx';
import GlobalHelper from "../common/GlobalHelper.jsx";
import Icon from "../common/icon/icon.component.jsx";
import ProposalPreviewModal from "../common/proposal/previewmodal.component.jsx";
import ButtonWrapper from '../common/rich-text/feature-protection-wrappers/buttonProtectionWrapper.component';
import LoadingSpinner from "../common/spinner/loading.component.jsx";
import Integrations from "../integration/Integrations.jsx";
import { getPriceListName } from "../name-helpers/priceListNameHelper";
import InternalNotes from "../order/internalnotes.component";
import QuoteEventsTimeLine from "../quote/analytics/eventstimeline.component.jsx";
import AnalyticsQuoteAmounts from "../quote/analytics/quoteamounts.component.jsx";
import AnalyticsQuoteEmails from "../quote/analytics/quoteemails.component.jsx";
import AnalyticsQuoteQuestions from "../quote/analytics/quotequestions.component.jsx";
import ProposalTimeSpentDoughnut from "../quote/analytics/timespentdoughnut.component.jsx";
import ProjectDetailsEditForm from '../quote/project/details.component.jsx';
import { Guard, Permissions } from "../role/Guard.jsx";
import { TYPE_EMAIL, TYPE_SMS } from '../state/conversation/ConversationThreadTypes';
import { isError } from "../state/helpers/Error";
import { REFUND_TYPE } from "../state/invoice/Constants";
import { BILLING_TYPE } from '../state/invoice/InvoiceBillingType';
import Invoice from "../state/invoice/models/invoice";
import RefundPayments from "../state/payment/refund/RefundPayments";
import RefundService from '../state/payment/refund/RefundService';
import DeleteInvoiceModal from "./components/DeleteInvoiceModal";
import PaymentRefundModal from './components/PaymentRefundModal/PaymentRefundModal';
import RefundConfirmationModal from './components/RefundConfirmationModal/RefundConfirmationModal';
import NewInvoiceModal from './newmodal.component';
import ReceivePaymentModal from "./receivepaymentmodal.component.jsx";
import ReturnModal from './returnmodal.component.jsx';
import InvoiceStatusTimeLine from "./statustimeline.component.jsx";
const uuidv4 = require("uuid/v4")

const REFUND_MODAL_ID = "payment-refund-modal-analytics-" + uuidv4()
class InvoiceAnalytics extends Component {

    constructor(props, context) {
        super(props, context)
        const integrations = AppContext.integrations.filter((integration) =>
            integration.attributes.enabled && integration.attributes.features.includes((Features.SentInvoiceExport)))
        this.state = {
            invoice: this.props.invoice || null,
            project: this.props.project || null,
            proposal: this.props.proposal || null,
            quoteReference: this.props.quoteReference || null,
            orderReference: this.props.orderReference || null,
            priceListReference: this.props.priceListReference || null,
            recurringInvoice: this.props.recurringInvoice || null,
            relatedInvoice: this.props.relatedInvoice || null,
            emails: this.props.emails || [],
            internalNotes: this.props.internalNotes || [],
            returns: this.props.returns || [],
            onRefresh: this.props.onRefresh || function () { },
            onEdit: this.props.onEdit || function () { },
            customFieldDefinitions: [],
            redirect: '',
            modal: '',
            moreLoading: false,
            accountLimit: null,
            isEditable: this.props.invoice && this.props.invoice.attributes.deletedAt === '',
            integrationsSupportingSentInvoiceExport: integrations,
            showAnalyticsQuoteQuestions: true,
            showDeleteInvoiceModal: false,
            availableCreditMemoFromReferences: [],
            applyMultipleCreditMemos: false,
            availableCreditMemoFromLinkedPriceList: [],
        }
        this.handleRefreshInvoice = this.handleRefreshInvoice.bind(this)
        this.archive = this.archive.bind(this)
        this.unarchive = this.unarchive.bind(this)
        this.handleCloseModal = this.handleCloseModal.bind(this)
        this.openReturnModal = this.openReturnModal.bind(this)
        this.openRefundModal = this.openRefundModal.bind(this)
        this.openPreview = this.openPreview.bind(this)
        this.exportWord = this.exportWord.bind(this)
        this.receivePayment = this.receivePayment.bind(this)
        this.handleCloseAndRefresh = this.handleCloseAndRefresh.bind(this)
        this.handleOnEdit = this.handleOnEdit.bind(this)
        this.exportIntegration = this.exportIntegration.bind(this)
        this.void = this.void.bind(this)
        this.printPdf = this.printPdf.bind(this)
        this.makeRecurring = this.makeRecurring.bind(this)
        this.createPackingSlip = this.createPackingSlip.bind(this)
        this.loadAnotherInvoice = this.loadAnotherInvoice.bind(this)
        this.deleteIntegrationLink = this.deleteIntegrationLink.bind(this)
        this.handleCloseAndRefreshReceivePaymentModal = this.handleCloseAndRefreshReceivePaymentModal.bind(this)
        this.handleSendEmailModal = this.handleSendEmailModal.bind(this)
        this.duplicate = this.duplicate.bind(this)
        this.openPriceListBulkPaymentModal = this.openPriceListBulkPaymentModal.bind(this)
        this.toggleInvoiceDeleteModal = this.toggleInvoiceDeleteModal.bind(this)
        this.handleRefund = this.handleRefund.bind(this)
        this.handleVoid = this.handleVoid.bind(this)
        this.mapOnAccountRefundResponseToRefundPaymentsResponse = this.mapOnAccountRefundResponseToRefundPaymentsResponse.bind(this)
    }

    componentDidMount() {
        AppContext.getApiClient().get('/account-limits').then(res => {
            this.setState({
                accountLimit: res,
            })
        })

        this.getAvailableCreditMemoFromReferences()
        AppContext.getApiClient().get('/templates/send-scheduling-page/template').then(t => {
            this.setState({
                schedulingPageTemplate: t,
            })
        })

        if (this.props.showReceivePaymentModal) {
            this.setState({
                modal: <ReceivePaymentModal
                    onClose={this.handleCloseAndRefreshReceivePaymentModal}
                    invoice={this.state.invoice}
                    paymentType="quote-deposit"
                />
            })
        }
    }

    componentWillReceiveProps(nextProps, nextContext) {
        if (nextProps.invoice && nextProps.invoice.attributes.balance !== this.state.invoice.attributes.balance &&
            nextProps.invoice.attributes.status !== 'fully-paid' &&
            this.state.availableCreditMemoFromReferences.length > 0 && this.state.applyMultipleCreditMemos) {
            this.setState({
                modal: <ReceivePaymentModal
                    onClose={this.handleCloseAndRefreshReceivePaymentModal}
                    invoice={nextProps.invoice}
                    paymentType={this.state.availableCreditMemoFromReferences[0].paymentType}
                />
            })
        }

        this.setState({
            invoice: nextProps.invoice || null,
            project: nextProps.project || null,
            proposal: nextProps.proposal || null,
            recurringInvoice: nextProps.recurringInvoice || null,
            relatedInvoice: nextProps.relatedInvoice || null,
            quoteReference: nextProps.quoteReference || null,
            orderReference: nextProps.orderReference || null,
            priceListReference: nextProps.priceListReference || null,
            emails: nextProps.emails || [],
            internalNotes: nextProps.internalNotes || [],
            returns: nextProps.returns || [],
            isEditable: nextProps.invoice && nextProps.invoice.attributes.deletedAt === '',
        }, () => {
            if (this.state.proposal && this.state.proposal.attributes.variables) {
                const documentInfoSection = this.state.proposal.attributes.variables.sections.find(s => s.attributes.contentType === 'document-info')
                if (documentInfoSection) {
                    this.setState({
                        showAnalyticsQuoteQuestions: !documentInfoSection.attributes.content.disableChat,
                    })
                } else {
                    this.setState({
                        showAnalyticsQuoteQuestions: false,
                    })
                }
            }
        })

        if (nextProps.showReceivePaymentModal) {
            this.getAvailableCreditMemoFromReferences()
            this.setState({
                modal: <ReceivePaymentModal
                    onClose={this.handleCloseAndRefreshReceivePaymentModal}
                    invoice={this.state.invoice}
                    paymentType="quote-deposit"
                />
            })
        }
    }

    duplicate(event) {
        event.preventDefault()
        const fromInvoiceId = this.state.invoice.id
        const fromProjectId = this.state.project.id
        const onClose = (newInvoiceId) => {
            if (!newInvoiceId) {
                this.setState({ modal: '' })
                return
            }
            this.setState({
                redirect: <Redirect to={`/invoices/${newInvoiceId}/edit`} />
            })
        }
        this.setState({
            modal: <NewInvoiceModal {...{ onClose, fromInvoiceId, fromProjectId }} />
        })
    }

    getDepositPaymentTypeToSetByDefault(creditMemo) {
        if (creditMemo.quoteReferenceId) {
            return 'quote-deposit'
        }
        if (creditMemo.orderReferenceId) {
            return 'order-deposit'
        }
    }

    getAvailableCreditMemoFromReferences() {
        let data = {
            keywords: '*',
            objects: ['credit-memos'],
            fields: ['identifier', 'contact.name'],
            pageSize: 1000,
            activePage: 1,
            sortByField: 'createdAt',
            sortAsc: false,
            filters: {
                "{oneOf}": {},
                "status": ['available', 'partially-applied'],
            },
            lightResult: true
        }
        if (this.state.invoice.attributes.quoteReferenceId) {
            data.filters["{oneOf}"].quoteReferenceIdKeyword = this.state.invoice.attributes.quoteReferenceId
        }
        if (this.state.invoice.attributes.orderReferenceId) {
            data.filters["{oneOf}"].orderReferenceId = this.state.invoice.attributes.orderReferenceId
        }
        if (this.state.invoice.attributes.priceListId) {
            data.filters["{oneOf}"].priceListId = this.state.invoice.attributes.priceListId
            data.filters["{oneOf}"].priceListReferenceId = this.state.invoice.attributes.priceListId
        }
        if (Object.keys(data.filters["{oneOf}"]).length === 0) {
            return
        }
        AppContext.getApiClient().post('/listing/search', data).then(res => {
            this.setState({
                availableCreditMemoFromReferences: res.data.map(c => {
                    return {
                        id: c.id,
                        paymentType: this.getDepositPaymentTypeToSetByDefault(c)
                    }
                }),
                availableCreditMemoFromLinkedPriceList: res.data.filter(c => c.priceListReferenceId && c.status === 'available')
            })
        })

    }

    handleRefreshInvoice(invoiceId) {
        invoiceId = invoiceId || this.state.invoice.id
        this.state.onRefresh(invoiceId)
    }

    handleOnEdit(e) {
        e.preventDefault()
        this.state.onEdit(this.state.invoice.id)
    }


    archive() {
        return AppContext.getApiClient().delete('/invoices/' + this.state.invoice.id, {}).then(q => {
            this.handleRefreshInvoice()
        })
    }

    unarchive(event) {
        event.preventDefault()
        return AppContext.getApiClient().put('/invoices/' + this.state.invoice.id + '/unarchive', {}).then(q => {
            this.setState({ editable: true })
            this.handleRefreshInvoice()
        })
    }

    handleCloseModal() {
        this.setState({
            modal: ''
        })
    }

    handleSendEmailModal(modal) {
        this.setState({
            modal: modal
        })
    }

    handleCloseAndRefresh() {
        this.setState({
            modal: ''
        })
        this.handleRefreshInvoice()
    }

    handleCloseAndRefreshReceivePaymentModal(paymentType, appliedCreditMemoId) {
        this.handleCloseAndRefresh()
        /* When you pay an invoice using a credit memo which is linked to one of this invoice's references,
         keep showing the payment modal with the next credit memo that also has a reference
         unless the user chooses a different payment type or close the modal manually or all linked credit memos are applied */
        if (appliedCreditMemoId && ['quote-deposit', 'order-deposit'].includes(paymentType) &&
            this.state.availableCreditMemoFromReferences.map(c => c.id).includes(appliedCreditMemoId)) {
            this.setState({
                availableCreditMemoFromReferences: this.state.availableCreditMemoFromReferences.filter(c => c.id !== appliedCreditMemoId),
            }, () => {
                if (this.state.availableCreditMemoFromReferences.length > 0) {
                    this.setState({
                        applyMultipleCreditMemos: true,
                    })
                } else {
                    this.setState({
                        applyMultipleCreditMemos: false,
                    })
                }
            })
        } else {
            this.setState({
                applyMultipleCreditMemos: false,
            })
        }
    }

    openReturnModal() {
        event.preventDefault()
        this.setState({
            modal: <ReturnModal
                onClose={
                    (returnId) => {
                        this.handleCloseModal()
                        this.handleRefreshInvoice(returnId)
                    }
                }
                invoice={this.state.invoice}
            />
        })
    }

    openPreview(event) {
        event.preventDefault()
        this.setState({
            modal: <ProposalPreviewModal
                onClose={this.handleCloseModal}
                hash={this.state.proposal.attributes.hash}
                pdfLink={this.state.proposal.attributes.variables.document.pdfUri}
                publicLink={this.state.proposal.attributes.publicLink}
                proposalType={'invoice'}
            />
        })
    }

    receivePayment(event) {
        event.preventDefault()
        this.setState({
            modal: <ReceivePaymentModal
                onClose={this.handleCloseAndRefreshReceivePaymentModal}
                invoice={this.state.invoice}
            />
        })
    }

    openRefundModal(event) {
        event.preventDefault()
        this.setState({
            modal:
                <PaymentRefundModal
                    id={REFUND_MODAL_ID}
                    onClose={this.handleCloseAndRefresh}
                    onRefund={this.handleRefund}
                    invoice={this.state.invoice}
                />
        })
    }

    async handleRefund(type, payload) {
        let refundPayments

        if (type === REFUND_TYPE.REFUND) {
            refundPayments = await RefundService.processRefund(this.state.invoice.id, payload)
        } else if (type === REFUND_TYPE.REFUND_ACCOUNT) {
            const response = await AppContext.getApiClient().post('/payment-transactions', payload)

            if (isError(response)) {
                return
            }

            refundPayments = this.mapOnAccountRefundResponseToRefundPaymentsResponse(response)
        }

        if ($("#" + REFUND_MODAL_ID)) {
            $("#" + REFUND_MODAL_ID).modal("hide")
        }

        this.setState({
            modal: <RefundConfirmationModal
                refundType={type}
                refundResponse={refundPayments}
                return={this.state.invoice}
                onClose={this.handleCloseAndRefresh()}
            />
        })
    }

    mapOnAccountRefundResponseToRefundPaymentsResponse(response) {
        let currencyFormatter = new Intl.NumberFormat(undefined, {
            style: 'currency',
            currency: this.state.invoice.attributes.currency,
        });

        const positiveTotal = this.state.invoice.attributes.totalAmount[0] === "-" ?
            this.state.invoice.attributes.totalAmount.substring(1) : this.state.invoice.attributes.totalAmount

        const dto = {
            id: "non-applicable",
            type: "refund-payments",
            attributes: {
                total: currencyFormatter.format(positiveTotal),
                refundPayments: [],
                currency: this.state.invoice.attributes.currency,
            }
        }


        response.data.forEach(invoice => {
            invoice.attributes.paymentTransactions.forEach(transaction => {

                const positiveAmount = transaction.attributes.payment.attributes.amount[0] === "-" ?
                    transaction.attributes.payment.attributes.amount.substring(1) : transaction.attributes.payment.attributes.amount

                dto.attributes.refundPayments.push({
                    id: transaction.attributes.payment.id,
                    type: "refund-payment",
                    attributes: {
                        identifier: transaction.attributes.payment.attributes.identifier,
                        amount: currencyFormatter.format(positiveAmount),
                        refundMethod: transaction.attributes.payment.attributes.type,
                        refundedPaymentId: "",
                        status: transaction.attributes.payment.attributes.status,
                    }
                })
            })
        })

        return new RefundPayments(dto)
    }



    async handleVoid(type, payload) {
        let refundPayments = await RefundService.processVoid(payload.invoiceId, payload)
        if (type === REFUND_TYPE.NO_REFUND) {
            $("#" + REFUND_MODAL_ID).modal("hide")
            this.handleCloseAndRefresh()
            return
        }

        if ($("#" + REFUND_MODAL_ID)) {
            $("#" + REFUND_MODAL_ID).modal("hide")
        }
        this.setState({
            modal: <RefundConfirmationModal
                refundType={type}
                refundResponse={refundPayments}
                return={this.state.invoice}
                onClose={this.handleCloseAndRefresh()}
            />
        })
    }



    void(event) {
        event.preventDefault()
        this.setState({
            modal:
                <PaymentRefundModal
                    id={REFUND_MODAL_ID}
                    onClose={this.handleCloseAndRefresh}
                    onRefund={this.handleVoid}
                    invoice={this.state.invoice}
                    void
                />
        })
    }

    makeRecurring(event) {
        event.preventDefault()
        AppContext.getApiClient().post('/invoices/' + this.state.invoice.id + '/recurring', {}).then(r => {
            if (!r.error) {
                this.state.onRefresh(r.id)
            }
        })
    }

    exportWord(event) {
        event.preventDefault()
        this.setState({
            moreLoading: true,
            modal: <div className={"d-none"}>
                <iframe width={1280} height={250} src={'/p/proposals/' + this.state.proposal.attributes.hash + '/word'} id={'wordFrame'} />
            </div>
        }, () => {
            setTimeout(() => {
                const header = "<html xmlns:o='urn:schemas-microsoft-com:office:office' " +
                    "xmlns:w='urn:schemas-microsoft-com:office:word' " +
                    "xmlns='http://www.w3.org/TR/REC-html40'>" +
                    "<head><meta charset='utf-8'><title>" + this.state.invoice.attributes.identifier + "</title></head><body>";
                const footer = "</body></html>";
                const iframe = document.getElementById('wordFrame');
                const innerDoc = iframe.contentDocument || iframe.contentWindow.document;
                const sourceHTML = header + innerDoc.getElementById("pdf-document").innerHTML + footer
                const source = 'data:application/vnd.ms-word;charset=utf-8,' + encodeURIComponent(sourceHTML);
                const fileDownload = document.createElement("a");
                document.body.appendChild(fileDownload);
                fileDownload.href = source;
                fileDownload.download = this.state.invoice.attributes.identifier + '.doc';
                fileDownload.click();
                document.body.removeChild(fileDownload);
                this.setState({ moreLoading: false })
            }, 4000)
        })
    }


    deleteIntegrationLink(event, extrenalLinkId) {
        event.preventDefault()
        return AppContext.getApiClient().delete('/invoices/' + this.state.invoice.id + '/external-links/' + extrenalLinkId).then(q => {
            this.handleRefreshInvoice()
        })
    }

    isIntegrationExportable() {
        return AppContext.hasFeatureIntegration(Features.SentInvoiceExport) &&
            ["sent", "partially-paid", "fully-paid"].includes(this.state.invoice.attributes.status)
    }

    exportIntegration(event, integrationKey) {
        event.preventDefault()
        this.setState({
            moreLoading: true,
        })
        const data = {
            exportIntegrationKey: integrationKey
        }
        return AppContext.getApiClient().post('/invoices/' + this.state.invoice.id + '/export', data).then(q => {
            setTimeout(() => {
                this.handleRefreshInvoice()
                this.setState({
                    moreLoading: false,
                })
            }, 6000)
        })
    }

    printPdf(e) {
        const printUrl = this.state.proposal.attributes.printUrl
        GlobalHelper.redirectToPrintPdf(printUrl)
        this.setState({
            moreLoading: false,
        })
    }

    loadAnotherInvoice(invoiceId) {
        return function (e) {
            e.preventDefault()
            this.state.onRefresh(invoiceId)
        }.bind(this)
    }

    createPackingSlip(e) {
        e.preventDefault()
        AppContext.getApiClient().post('/proposals', {
            proposalId: this.state.proposal.id,
            contactId: this.state.invoice.attributes.contactId,
            type: 'packing-slip',
        }).then(res => {
            this.setState({
                modal: <Redirect to={'/proposals/' + res.attributes.hash + '/preview'} />
            })
        })
    }

    isReturn() {
        return this.state.invoice && this.state.invoice.attributes.billingType === BILLING_TYPE.RETURN
    }

    hasPaymentTransactions() {
        return this.state.invoice &&
            this.state.invoice.attributes.paymentTransactions.filter(p => !p.attributes.deleted).length > 0
    }

    renderIntegrationLogo(integrationKey) {
        return Integrations.getIntegrationLogoImage(integrationKey, '75')
    }

    openPriceListBulkPaymentModal(event) {
        event.preventDefault()
        const currency = this.state.invoice.attributes.currency
        const creditMemoIds = this.state.availableCreditMemoFromLinkedPriceList
            .filter(c => c.currency === currency)
            .map(c => c.id)
        let filters = {
            "fields": ["_id"],
            "filters": {
                "_id": creditMemoIds,
            },
            "keywords": "*",
            "objects": ["credit-memos"],
            "sortByField": "identifier",
        }

        let expectedAmount = 0
        for (let c of this.state.availableCreditMemoFromLinkedPriceList) {
            expectedAmount = expectedAmount + parseFloat(c.amount)
        }
        const metadata = {
            "amount": expectedAmount.toString(),
            "invoiceId": this.state.invoice.id,
            "priceListId": this.state.priceListReference.id,
            "currency": currency,
        }

        const disabledStartButton = this.state.invoice.attributes.balance < expectedAmount
        const modalContent = (
            <h5 className="border-bottom-0">
                {
                    !disabledStartButton ?
                        <p>
                            <FormattedMessage
                                id="invoice.analytics.bulk_payments_warning"
                                defaultMessage="Are you sure you want to bulk apply {numberOfCreditMemos} credit memos from the related {priceList} {priceListIdentifier} ?"
                                values={{
                                    numberOfCreditMemos: this.state.availableCreditMemoFromLinkedPriceList.length,
                                    priceListIdentifier: this.state.priceListReference.attributes.identifier,
                                    priceList: getPriceListName(this.props.intl)
                                }}
                            />
                        </p>
                        :
                        <p>
                            <FormattedMessage
                                id="invoice.analytics.bulk_payment_expected_amount_warning"
                                defaultMessage="Cannot bulk apply {numberOfCreditMemos} credit memos from {priceListIdentifier} because the total value exceeds the invoice's balance."
                                values={{
                                    numberOfCreditMemos: this.state.availableCreditMemoFromLinkedPriceList.length,
                                    priceListIdentifier: this.state.priceListReference.attributes.identifier,
                                }}
                            />
                        </p>
                }
                <h6>
                    <div class={"alert " + (!disabledStartButton ? "alert-info" : "alert-warning")} role="alert">
                        <FormattedMessage
                            id="invoice.analytics.bulk_payment_expected_amount"
                            defaultMessage="Expected total amount to be applied: {amount}"
                            values={{
                                amount: <FormattedNumber
                                    style="currency"
                                    currency={currency}
                                    value={metadata.amount}
                                />,
                            }}
                        />
                    </div>
                </h6>
            </h5>
        )
        this.setState({
            modal: <BulkModal
                filters={filters}
                operationType={"apply-price-list-bulk-payment"}
                metadata={metadata}
                numberOfItemsSelected={creditMemoIds.length}
                onClose={() => {
                    this.setState({ modal: '' })
                }}
                onCreate={(res) => {
                    if (!res.error) {
                        this.setState({
                            bulkPaymentOperationStarted: true,
                        })
                    } else {
                        this.setState({ modal: '' })
                    }
                }}
                disabled={disabledStartButton}
            >
                {modalContent}
            </BulkModal>
        })
    }


    renderPriceListBulkPaymentButton() {
        const showButton = this.state.invoice.attributes.isPriceListFinalInvoice &&
            !this.state.invoice.attributes.hasPendingBulkPayment &&
            this.state.invoice.attributes.balance > 0 &&
            this.state.priceListReference &&
            this.state.availableCreditMemoFromLinkedPriceList.length > 0

        return showButton ? <Button
            className="btn btn-primary mr-2 mb-2"
            onClick={this.openPriceListBulkPaymentModal}
            disabled={this.state.bulkPaymentOperationStarted}>
            {
                !this.state.bulkPaymentOperationStarted ?
                    <>
                        <Icon value={"dollar-sign"} className={"mr-1"} />
                        <FormattedMessage
                            id="invoice.analytics.receive_bulk_payments_btn"
                            defaultMessage="Apply {numberOfCreditMemos} credit memos from {priceList}"
                            values={{
                                numberOfCreditMemos: this.state.availableCreditMemoFromLinkedPriceList.length,
                                priceList: getPriceListName(this.props.intl),
                            }}
                        />
                    </>
                    :
                    <FormattedMessage
                        id="invoice.analytics.receive_bulk_payment_started"
                        defaultMessage="Bulk payment has started"
                    />
            }
        </Button> : ''
    }

    toggleInvoiceDeleteModal() {
        this.setState({
            showDeleteInvoiceModal: !this.state.showDeleteInvoiceModal
        })
    }

    render() {
        if (!this.state.invoice || !this.state.proposal) {
            return <div />
        }

        const contact = this.state.invoice.attributes.contact
        let contactPrimaryPhoneNumber = ''
        let contactPrimaryPhoneNumberExtension = ''
        for (let i = 0; i < contact.attributes.phoneNumbers.length; i++) {
            if (contact.attributes.phoneNumbers[i]["type"] === "primary") {
                contactPrimaryPhoneNumber = contact.attributes.phoneNumbers[i]["phoneNumber"]
                contactPrimaryPhoneNumberExtension = contact.attributes.phoneNumbers[i]["extension"]
            }
        }
        const isVoided = this.state.invoice.attributes.status === 'voided'
        return <div className={'row analytics-page py-3 mb-5'}>
            {this.state.redirect}
            {this.state.modal}
            <div className="col-12">
                <div className={"row"}>
                    <div className={"col-12"}>
                        <ProjectDetailsEditForm
                            invoice={this.state.invoice}
                            priceListReference={this.state.priceListReference}
                            quoteReference={this.state.quoteReference}
                            orderReference={this.state.orderReference}
                            recurringInvoice={this.state.recurringInvoice}
                            relatedInvoice={this.state.relatedInvoice}
                            proposal={this.state.proposal}
                            project={this.state.project}
                            isEditable={false}
                            loadAnotherInvoice={this.loadAnotherInvoice}
                        />
                    </div>
                </div>
            </div>
            <div className="col-12 ui-module">
                <div className={"row align-items-baseline justify-content-between px-3 d-flex"}>
                    <AnalyticsQuoteAmounts
                        showFullTotal={true}
                        invoice={this.state.invoice}
                        proposal={this.state.proposal}
                        returns={this.state.returns}
                    />

                    {!this.isReturn() && <div className={'row flex-grow-1'}>
                        <div className={'col-12 border-left'}>
                            <ProposalTimeSpentDoughnut
                                proposalType={this.state.proposal.attributes.variables.document.type}
                                visits={this.state.proposal.attributes.visits}
                                totalTimeSpent={this.state.proposal.attributes.totalTimeSpent}
                                totalTimeSpentOnPricing={this.state.proposal.attributes.totalTimeSpentOnPricingTable}
                            />
                        </div>
                    </div>}
                </div>
                {!this.isReturn() && <div>
                    <div className={"row"}>
                        <div className={'col-12'}>
                            <hr />
                        </div>
                    </div>
                    <InvoiceStatusTimeLine invoice={this.state.invoice} />
                </div>}
                <div className={"row"}>
                    <div className={'col-12'}>
                        <hr />
                    </div>
                </div>
                <div className={"row align-items-baseline"}>
                    <div className={'col-6 mt-2'}>
                        <div className={'row pl-3'}>
                            <div className={'col-12 p-2 border-right'}>
                                <InternalNotes
                                    projectObject={this.state.project}
                                    onRefresh={this.handleRefreshInvoice}
                                    internalNotes={this.state.internalNotes}
                                />
                            </div>
                        </div>
                    </div>
                    <div className={'col-6 pl-3'}>
                        {this.state.showAnalyticsQuoteQuestions && AppContext.accountFeatureIsEnabled(AccountFeatures.FeatureSms) &&

                            [<div className={'w-100'}>
                                <label className="col-form-label custom-form-label pt-2 mt-1">
                                    <strong>
                                        <FormattedMessage
                                            id="invoice.analytics.questions_and_answers_sms_label"
                                            defaultMessage="SMS"
                                        />
                                    </strong>
                                </label>
                            </div>,
                            <AnalyticsQuoteQuestions
                                project={this.state.project}
                                publicLink={this.state.proposal.attributes.publicLink}
                                selectedThread={GlobalHelper.getConversationThreadIndex(this.props.project?.attributes?.conversationThreads || [], TYPE_SMS)}
                                threadType={TYPE_SMS}
                                onClose={this.handleCloseAndRefresh}
                                invoiceId={this.state.invoice.id}
                                contactFirstName={this.state.invoice.attributes.contact.attributes.firstName} />]
                        }
                        {this.state.showAnalyticsQuoteQuestions &&
                            [<div className={'w-100'}>
                                <label className="col-form-label custom-form-label pt-2 mt-1">
                                    <strong>
                                        <FormattedMessage
                                            id="invoice.analytics.questions_and_answers_label"
                                            defaultMessage="Questions and answers"
                                        />
                                    </strong>
                                </label>
                            </div>,
                            <AnalyticsQuoteQuestions
                                project={this.state.project}
                                selectedThread={GlobalHelper.getConversationThreadIndex(this.props.project?.attributes?.conversationThreads || [], TYPE_EMAIL)}
                                threadType={TYPE_EMAIL}
                                onClose={this.handleCloseAndRefresh}
                                invoiceId={this.state.invoice.id}
                                contactFirstName={this.state.invoice.attributes.contact.attributes.firstName} />]
                        }
                        <div className={'w-100'}>
                            <label className="col-form-label custom-form-label pt-2 mt-1">
                                <strong>
                                    <FormattedMessage
                                        id="invoice.analytics.emails_label"
                                        defaultMessage="Emails"
                                    />
                                </strong>
                            </label>
                        </div>
                        <AnalyticsQuoteEmails
                            project={this.state.project}
                            proposal={this.state.proposal}
                            emails={this.state.emails}
                            onChange={this.handleRefreshInvoice}
                            isEditable={this.state.isEditable}
                        />
                    </div>
                </div>
            </div>
            <div className={'col-12 px-0'}>
                <QuoteEventsTimeLine
                    emails={this.state.emails}
                    invoice={this.state.invoice}
                    proposal={this.state.proposal}
                    project={this.state.project}
                    returns={this.state.returns}
                    isEditable={this.state.isEditable}
                    onUpdate={this.handleRefreshInvoice}
                />
            </div>
            <div className="row m-0 py-1 fixed-bottom pr-0 pr-md-5 pr-xl-0">
                <div className={'col-lg-12 mx-auto col-xl-11 pt-3 pl-4 pr-4 pr-md-5 pr-xl-4'}>
                    <div className="col-12 ui-module sticky-bottom-module">
                        <div className="row justify-content-end">
                            {this.state.isEditable ? <div className="col-12 d-flex justify-content-between align-content-center flex-wrap">
                                <div className={"d-flex"}>
                                    <div className={""}>
                                        {!this.isReturn() && !isVoided && (this.hasPaymentTransactions() || this.state.invoice?.attributes?.refunded) ?
                                            <button className={"btn btn-sm btn-warning mr-2 mb-2"} onClick={this.openReturnModal} >
                                                <Icon value={"undo"} className={"mr-1"} />
                                                <FormattedMessage
                                                    id="invoice.analytics.return_btn"
                                                    defaultMessage="Return"
                                                />
                                            </button> : (this.isReturn() || isVoided || this.state.invoice?.attributes?.refunded) ? "" :
                                                <button className={"btn btn-sm btn-outline-danger mr-2 mb-2"} onClick={this.void}>
                                                    <Icon value={"ban"} className={"mr-1"} />
                                                    <FormattedMessage
                                                        id="quote.analytics.void_btn"
                                                        defaultMessage="Void"
                                                    />
                                                </button>
                                        }
                                        <button className={"btn btn-sm btn-outline-primary mr-2 mb-2"} onClick={this.openPreview} >
                                            <Icon value={"eye"} className={"mr-1"} />
                                            <FormattedMessage
                                                id="invoice.analytics.preview_btn"
                                                defaultMessage="Preview"
                                            />
                                        </button>
                                        <a className={'btn btn-sm btn-outline-primary mr-2 mb-2'} href={this.state.proposal.attributes.publicLink} target={'_blank'}>
                                            <Icon value={"external-link-alt"} className={"mr-1"} />
                                            {!this.isReturn() ? <FormattedMessage
                                                id="invoice.analytics.open_invoice_btn"
                                                defaultMessage="Open invoice"
                                            /> : <FormattedMessage
                                                id="invoice.analytics.open_return_btn"
                                                defaultMessage="Open return"
                                            />}
                                        </a>
                                        {!this.isReturn() && <span>
                                            {this.state.invoice.attributes.packingSlipHash ? <Link to={'/proposals/' + this.state.invoice.attributes.packingSlipHash + '/preview'} className={'mr-2 mb-2 btn btn-sm btn-outline-primary'}>
                                                <Icon value={'box-open'} className={'mr-1'} />
                                                <FormattedMessage
                                                    id="quote.analytics.packing_slip_btn"
                                                    defaultMessage="Packing slip"
                                                />
                                            </Link> : <ActionButton target={'_blank'} href={'#'} className={'mr-2 mb-2 btn btn-sm btn-outline-primary'} onClick={this.createPackingSlip}>
                                                <Icon value={'box-open'} className={'mr-1'} />
                                                <FormattedMessage
                                                    id="quote.analytics.packing_slip_btn"
                                                    defaultMessage="Packing slip"
                                                />
                                            </ActionButton>}
                                        </span>}
                                        {(!GlobalHelper.hasShopifyIntegrationWithDisabledFeatures() && !this.state.invoice.attributes.recurringInvoiceId && !this.isReturn())
                                            ? <ActionButton className="btn btn-sm btn-outline-primary mr-2 mb-2" onClick={this.makeRecurring}>
                                                <Icon value={"sync"} className={"mr-1"} />
                                                <FormattedMessage
                                                    id="quote.analytics.make_recurring_btn"
                                                    defaultMessage="Make recurring"
                                                />
                                            </ActionButton> : ''}
                                    </div>
                                    <div className="mr-2 mb-2 ">
                                        <button
                                            className="btn btn-sm btn-outline-primary"
                                            type="button" id="dropdownMoreButton"
                                            data-toggle="dropdown"
                                            aria-haspopup="true"
                                            aria-expanded="false"
                                            disabled={this.state.moreLoading}>
                                            {!this.state.moreLoading ? <Icon value={"ellipsis-h"} className={"mr-1"} /> : <LoadingSpinner
                                                height={15}
                                                width={3}
                                                className="px-5"
                                            />}
                                        </button>
                                        <div className="dropdown-menu" aria-labelledby="dropdownMoreButton">
                                            <a className="dropdown-item" href="#" onClick={this.duplicate}>
                                                <Icon value={"clone"} className={"mr-1"} />
                                                <FormattedMessage
                                                    id="quote.analytics.duplicate_btn"
                                                    defaultMessage="Duplicate"
                                                />
                                            </a>

                                            <a className="dropdown-item" href="#" onClick={this.exportWord}>
                                                <Icon value={"file-word"} className={"mr-1"} />
                                                <FormattedMessage
                                                    id="quote.analytics.word_export_btn"
                                                    defaultMessage="Export to word"
                                                />
                                            </a>
                                            <a className="dropdown-item" href="#" onClick={this.printPdf}>
                                                <Icon value={"print"} className={"mr-1"} />
                                                <FormattedMessage
                                                    id="quote.analytics.print_btn"
                                                    defaultMessage="Print"
                                                />
                                            </a>
                                            {!isVoided && Guard.isAuthorized(Permissions.EditInvoiceAfterSent) ? <a className="dropdown-item" href="#" onClick={this.handleOnEdit}>
                                                <Icon value={"pen"} className={"mr-1"} />
                                                <FormattedMessage
                                                    id="quote.analytics.edit_btn"
                                                    defaultMessage="Edit"
                                                />
                                            </a> : ''}

                                            {this.isIntegrationExportable() && Guard.isAuthorized(Permissions.ManualInvoiceExport) &&
                                                this.state.integrationsSupportingSentInvoiceExport.map(integration => {
                                                    const integrationKey = integration.attributes.integrationKey
                                                    const shouldDisplayExportButton = GlobalHelper.shouldDisplayInvoiceManualExportButton(this.state.invoice.attributes, integrationKey, this.isReturn())
                                                    return shouldDisplayExportButton &&
                                                        <a className="dropdown-item" href="#" onClick={(e) => this.exportIntegration(e, integrationKey)}>
                                                            <Icon value={"cloud-upload-alt"} className={"mr-1"} />
                                                            <FormattedMessage
                                                                id="invoice.analytics.integration_export_btn"
                                                                defaultMessage="Export to {integrationName}"
                                                                values={{
                                                                    integrationName: <span className="ml-1">
                                                                        {this.renderIntegrationLogo(integrationKey)}
                                                                    </span>
                                                                }}
                                                            />
                                                        </a>
                                                })
                                            }

                                            {AppContext.getUserLoggedIn().attributes.superUser && this.state.invoice.attributes.externalLinks ?
                                                this.state.invoice.attributes.externalLinks.map(externalLink => {
                                                    const integrationKey = externalLink.attributes.integrationKey
                                                    const id = externalLink.id
                                                    const entityType = externalLink.attributes.entityType
                                                    return <a className="dropdown-item text-danger" href="#" onClick={(e) => this.deleteIntegrationLink(e, id)}>
                                                        <Icon value={"trash"} className={"mr-1"} />
                                                        <FormattedMessage
                                                            id="invoice.analytics.integration_delete_integration_link_btn"
                                                            defaultMessage="Delete integration Link ({entityType}){integrationName}"
                                                            values={{
                                                                integrationName: <span className="ml-1">
                                                                    {this.renderIntegrationLogo(integrationKey)}
                                                                </span>,
                                                                entityType: entityType
                                                            }}
                                                        />
                                                    </a>
                                                }) : ''
                                            }

                                            {Guard.isAuthorized(Permissions.DeleteInvoice) &&
                                                <a className="dropdown-item text-danger" href="#" onClick={(e) => this.toggleInvoiceDeleteModal()}>
                                                    <Icon value={"trash"} className={"mr-1"} />
                                                    <FormattedMessage
                                                        id="invoice.analytics.delete_btn"
                                                        defaultMessage="Delete"
                                                    />
                                                </a>
                                            }
                                            {this.state.showDeleteInvoiceModal &&
                                                <DeleteInvoiceModal
                                                    show={this.state.showDeleteInvoiceModal}
                                                    onHide={this.toggleInvoiceDeleteModal}
                                                    invoice={new Invoice(this.state.invoice)}
                                                    onDelete={this.archive}
                                                />
                                            }

                                            {!this.state.invoice.attributes.refunded ?
                                                (!isVoided && Guard.isAuthorized(Permissions.VoidInvoice) && !this.isReturn())
                                                    && this.hasPaymentTransactions() ?
                                                    <a className="dropdown-item text-danger" href="#" onClick={this.void}>
                                                        <Icon value={"ban"} className={"mr-1"} />
                                                        <FormattedMessage
                                                            id="quote.analytics.void_btn"
                                                            defaultMessage="Void"
                                                        />
                                                    </a> : (this.isReturn() || isVoided) ? "" :
                                                        <a className="dropdown-item text-warning" href="#" onClick={this.openReturnModal} >
                                                            <Icon value={"undo"} className={"mr-1"} />
                                                            <FormattedMessage
                                                                id="invoice.analytics.return_btn"
                                                                defaultMessage="Return"
                                                            />
                                                        </a> : ""
                                            }

                                        </div>
                                    </div>

                                </div>
                                <div className={""}>

                                    <SendSchedulingPageButton
                                        typeOfDocument={"invoices"}
                                        invoiceId={this.state.invoice.id}
                                        invoice={this.state.invoice}
                                        handleSendEmailModal={this.handleSendEmailModal}
                                        handleCloseModal={this.handleCloseModal}
                                    />

                                    {['sent'].includes(this.state.invoice.attributes.status) && this.state.invoice.attributes.scheduledPaymentDate ? <span className={"mr-2"}>
                                        <FormattedMessage
                                            id="invoice.analytics.scheduled_payment_notice"
                                            defaultMessage="A payment is scheduled on {date} for an amount of {amount}"
                                            values={{
                                                date: <FormattedDate
                                                    year='numeric'
                                                    month='long'
                                                    day='numeric'
                                                    value={new Date(this.state.invoice.attributes.scheduledPaymentDate)} />,
                                                amount: <FormattedNumber
                                                    style="currency"
                                                    currency={this.state.invoice.attributes.currency}
                                                    value={this.state.invoice.attributes.scheduledPaymentAmount}
                                                />,
                                            }}
                                        />
                                    </span> : ''}

                                    {
                                        this.renderPriceListBulkPaymentButton()
                                    }
                                    {['sent', 'partially-paid'].includes(this.state.invoice.attributes.status) &&
                                        this.state.invoice.attributes.balance > 0 && this.state.accountLimit &&
                                        <ButtonWrapper
                                            message={GlobalHelper.isAccountLimitExceeded(this.state.accountLimit) ?
                                                <FormattedMessage
                                                    id="listing.search.invoice_document_limit"
                                                    defaultMessage="Documents limit exceeded."
                                                /> : ''}
                                            isProtected={true}
                                            onClick={(e) => this.receivePayment(e)}
                                            className={"btn btn-success mr-2 mb-2"}
                                            protectedClassName={"btn btn-success mr-2 mb-2"}
                                            tooltipPosition={"top"}
                                            premium={false}
                                            protectionRule={(!GlobalHelper.isAccountLimitExceeded(this.state.accountLimit)) ||
                                                (this.state.invoice.attributes.importedAt === "")}>
                                            <span>
                                                <Icon value={"dollar-sign"} className={"mr-1"} />
                                                <FormattedMessage
                                                    id="invoice.analytics.receive_payment_btn"
                                                    defaultMessage="Receive payment"
                                                />
                                            </span>
                                        </ButtonWrapper>
                                    }

                                    {['sent', 'partially-paid'].includes(this.state.invoice.attributes.status) &&
                                        this.isReturn() && this.state.invoice.attributes.balance < 0 && <button className="btn btn-warning mr-2 mb-2" onClick={this.openRefundModal}>
                                            <Icon value={"dollar-sign"} className={"mr-1"} />
                                            <FormattedMessage
                                                id="invoice.analytics.refund_btn"
                                                defaultMessage="Refund"
                                            />
                                        </button>}

                                </div>
                            </div> : [<div className="col-3" key={"1"}>
                                <ActionButton className={"btn btn-sm btn-warning mr-2 mb-2"} onClick={this.unarchive}>
                                    <FormattedMessage
                                        id="invoice.analytics.unarchive_btn"
                                        defaultMessage="Unarchive"
                                    />
                                </ActionButton>
                            </div>,
                            <div className="col-9" key={"2"}>
                                <p className="text-align-right text-warning m-0">
                                    <FormattedMessage
                                        id="invoice.analytics.archived_invoice_info"
                                        defaultMessage="This invoice is archived and can't be found in search results."
                                    />
                                </p>
                            </div>]}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    }

}

export default injectIntl(InvoiceAnalytics)





// WEBPACK FOOTER //
// ./src/invoice/analytics.component.jsx